import React, { FC, Fragment } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Tip } from 'components';
import Update from './Update';
import Create from './Create';
import { ClientDisclosure } from 'api';

interface IProps {
  list: ClientDisclosure[];
}

const useStyles = makeStyles(theme => ({
  spacer: {
    height: theme.spacing(2),
  },
}));

const Disclosures: FC<IProps> = ({ list }) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Create />
      <div className={classes.spacer} />
      <Grid container direction="column" spacing={2}>
        {list.map(disclosure => (
          <Grid item key={disclosure.id}>
            <Update disclosure={disclosure} />
          </Grid>
        ))}
      </Grid>
      <Grid container>
        <Grid item xs={3} />
        <Grid item xs={7}>
          <Tip i18nKey="admin:disclosureTip" />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Disclosures;
